var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},_vm._l((_vm.items),function(item,index){return _c('div',{class:{'dropdown__option' : true, 'open' : _vm.current_selection == index}},[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.current_selection = index}}},[_vm._v("\n            "+_vm._s(item)+"\n        ")])])}),0)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79594b7f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/vue/dropdown.vue
// module id = 48
// module chunks = 0